export default __webpack_public_path__ + "static/bbqguru-1-63809013c6325f9ddc4d9768727417ff.webp";